import { ReactComponent as File } from "assets/youtube.svg";
import IconContent from "../Icon.interface";
import React, { FunctionComponent } from "react";

const Icon: FunctionComponent<IconContent> = (props): JSX.Element => {
    return (
        <File className={props.className} />
    );
};

export default Icon;